import { render, staticRenderFns } from "./ModalPlain.vue?vue&type=template&id=e190fdc4&scoped=true&"
import script from "./ModalPlain.vue?vue&type=script&lang=ts&"
export * from "./ModalPlain.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPlain.vue?vue&type=style&index=0&id=e190fdc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e190fdc4",
  null
  
)

export default component.exports